export default class {
    constructor(model, controller) {
        this.model = model;
        this.controller = controller;
        this.children = [];
    }

    setModel(model) {
        this.model = model;
    }
    setController(controller) {
        this.controller = controller;
    }
    setRootEl(element) {
        this.rootEl = element;
    }

    getModel() {
        return this.model;
    }
    getController() {
        return this.controller;
    }
    getRootEl() {
        return this.rootEl;
    }

    addChild(child) {
        if (this.children.indexOf(child) > -1) {
            return;
        }
        this.children.push(child);
        child.parentNode = this;
    }
}



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/mixins/view.js